import sortedIndex from "./sortedIndex.js";
import findIndex from "./findIndex.js";
import createIndexFinder from "./_createIndexFinder.js";
export default createIndexFinder(1, findIndex, sortedIndex);
